<template>
    <div id="app">
        <!-- This will be reaplced by the view defined in the router -->
        <router-view></router-view>

        <footer class="tw-flex tw-items-center tw-justify-center">
            <div class="tw-container tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-5 lg:tw-flex-row lg:tw-items-center lg:tw-gap-20">
                <img src="~@/assets/img/logo-footer.svg" alt="GoldFinance">
                <p>
                    A <b>GoldFinance</b> é uma empresa Portuguesa composta por mediadores com grande experiência no mercado financeiro, tanto de crédito consolidado, crédito habitação, crédito pessoal e seguros de vida. Estamos registados como Intermediários de Crédito Vinculado sob o n.º 2306 no Banco de Portugal e na ASF com o registo mediador n.º 417450816/3.
                </p>
            </div>
        </footer>

        <ModalContainer>
            <Terms/>
        </ModalContainer>

        <Clarity/>

        <KwPixel v-if="$store.state.formSuccess"/>
    </div>
</template>

<script>
import axios from 'axios';
import KwPixel from '@/components/KwPixel.vue';
import ModalContainer from '@/components/ModalContainer.vue';
import Terms from '@/components/Terms.vue';
import Clarity from '@/components/Clarity.vue';

export default {
    components: {
        KwPixel,
        Clarity,
        ModalContainer,
        Terms,
    },
    created() {
        const data = {
            url: window.location.hostname,
            pubid: this.$route.query.pubid || null,
            utm_source: this.$route.query.utm_source || null,
            utm_campaign: this.$route.query.utm_campaign || null,
            utm_medium: this.$route.query.utm_medium || null,
            utm_content: this.$route.query.utm_content || null,
            utm_term: this.$route.query.utm_term || null,
        };
        axios.post(`${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/trk`, data)
            .then((response) => {
                this.$store.state.token = response.data.token;
            })
            .catch((error) => {
                console.log(error.response.data);
            });
    },
    mounted() {
        window.cmp_setlang = document.documentElement.lang;
    },
};
</script>
<style>

</style>
